import { put, call, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { IServiceConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'

export function* setCommandFacProcedureDefaultAction() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: IServiceConfigResponse = yield call([
      configurationsService,
      configurationsService.getCommandFacilityProcedureActionDefaults,
    ])
    const { entity } = response
    yield put(actions.setCommandFacilityProcedureDefaultAction(entity))
  } catch (e) {
    yield put(throwPcrException(`setCommandFacProcedureDefaultAction() error: ${e}`))
  }
}
export function* setCommandFacProcedureDefaultActionSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCommandFacProcedureDefaultAction)
}
